import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { countryValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm, Switch } from "antd";
import CountryModal from "Components/Modal/master/country";
import ToastNotification from "Components/UI/ToastNotification";
import {
  useDeleteCountryMutation,
  useGetCountriesQuery,
  useInsertCountryMutation,
  useUpdateCountryMutation,
} from "AppQuries/master/Country/country";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";

const Country = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetCountriesQuery(
    {
      companyCode: userData?.companyCode,
    },
    {
      enabled: userData?.companyCode,
    }
  );
  const methods = useForm({
    resolver: yupResolver(countryValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem, isPending: isAdding } = useInsertCountryMutation();
  const { mutate: updateItem, isPending: isUpdating } =
    useUpdateCountryMutation();

  const { mutate: deleteItem, isPending: isDeleting } =
    useDeleteCountryMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      countryCode: 0,
      country: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      countryCode: item.countryCode,
      country: item.country,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          setMessage("Item Deleted Successfully.");
          setShowSuccessToast(true);
          setSelectedItem(null);
          setShow(false);
          GetItems();
        } else {
          setMessage(data?.[0]?.errorMessage || "Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };

  const onSubmit = async (payload) => {
    console.log(payload);
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          if (data) {
            setMessage("Updated Successfully.");
            setShowSuccessToast(true);
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            setMessage(data?.[0]?.errorMessage || "Something went wrong.");
            setShowErrorToast(true);
          }
        },
        onError: (error) => {
          setMessage(error.message || "Something went wrong.");
          setShowErrorToast(true);
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          console.log(data);
          if (data?.[0]?.response) {
            setMessage("Created Successfully.");
            setShowSuccessToast(true);
            setShow(false);
            GetItems();
          } else {
            setMessage(data?.[0]?.errorMessage || "Something went wrong.");
            setShowErrorToast(true);
          }
        },
        onError: (error) => {
          setMessage(error.message || "Something went wrong.");
          setShowErrorToast(true);
        },
      });
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },
    {
      title: "Country",
      dataIndex: "country",
      sorter: (a, b) => a.country.length - b.country.length,
    },
    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_country}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          {/* <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_country}
            accessType="haveDelete"
          >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.code)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger>
          </Can> */}
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isAdding || isUpdating) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>Country</h4>
              <h6>Manage Contries</h6>
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_country}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Country</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
              </Can>
              &nbsp;
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link to={`${all_routes.master}`} className="btn btn-secondary">
                  <i className="fas fa-reply me-2"></i>
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                // showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <CountryModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default Country;
